import { Button } from "@/components/ui/button";
import { useLanguage } from "@/hooks/useLanguage";

interface StoryNavigationProps {
  storyParts: Array<{
    id: string;
    title: string;
    sequence_number: number;
  }>;
  currentStoryId: string;
  onPartClick: (partId: string) => void;
}

const StoryNavigation = ({ storyParts, currentStoryId, onPartClick }: StoryNavigationProps) => {
  const { t } = useLanguage();

  if (storyParts.length === 0) return null;

  return (
    <div className="mb-6 flex gap-2 items-center">
      <span className="text-white/60">{t('story.parts')}:</span>
      <div className="flex gap-2">
        {storyParts.map((part, index) => (
          <Button
            key={part.id}
            variant={part.id === currentStoryId ? "default" : "outline"}
            size="sm"
            onClick={() => onPartClick(part.id)}
            className="text-white"
          >
            {`${t('story.part')} ${index + 1}`}
          </Button>
        ))}
      </div>
    </div>
  );
};

export default StoryNavigation;